import React, { useState } from "react";
import {
  Box,
  Checkbox,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  DialogContent,
  Card,
  CardHeader,
  CardContent,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Button,
  Chip,
  Avatar,
  Stack,
  Divider,
  LinearProgress,
  useMediaQuery,
  useTheme,
  CircularProgress,
  InputAdornment,
  alpha,
} from "@mui/material";
import { DesktopDatePicker, MobileDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  Close as CloseIcon,
  Add as AddIcon,
  Download as DownloadIcon,
  CalendarToday as CalendarIcon,
  AccessTime as AccessTimeIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Pending as PendingIcon,
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  AttachFile as AttachFileIcon,
  Send as SendIcon,
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  EmojiEvents as TrophyIcon,
  Star as StarIcon,
  TrendingUp as TrendingUpIcon,
  MedicalServices as MedicalIcon,
  BeachAccess as VacationIcon,
  Celebration as CelebrationIcon,
  Favorite as FavoriteIcon,
  ArrowUpward as ArrowUpIcon,
  ArrowDownward as ArrowDownIcon,
  EventNote as EventIcon,
} from "@mui/icons-material";

function LeaveAttendance() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
  const [leaveType, setLeaveType] = useState("");
  const [reason, setReason] = useState("");
  const [halfEnd, setHalfEnd] = useState("");
  const [endDate, setEndDate] = useState(null);
  const [halfStart, setHalfStart] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [errors, setErrors] = useState({});
  const [openLeaveDialog, setOpenLeaveDialog] = useState(false);
  const [openLeaveDetails, setOpenLeaveDetails] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filterStatus, setFilterStatus] = useState("all");
  const [currentYear, setCurrentYear] = useState(dayjs().year());
  const [attachment, setAttachment] = useState(null);

  const tableData = [
    { label: "Credited Leaves", values: Array(12).fill(0) },
    { label: "Applied Leaves", values: Array(12).fill(2) },
    { label: "Approved Leaves", values: Array(12).fill(1) },
    { label: "Loss Of Pay", values: Array(12).fill(0) },
    { label: "Penalty Deduction", values: Array(12).fill(0) },
    { label: "Closing Balance", values: Array(12).fill(1) },
  ];

  const leaveData = [
    {
      id: 1,
      title: "EARNED LEAVE",
      details: [
        { label: "Credited", value: "15", icon: <StarIcon fontSize="small" /> },
        { label: "Total", value: "15", icon: <EventIcon fontSize="small" /> },
        { label: "Applied", value: "2", icon: <CalendarIcon fontSize="small" /> },
        { label: "Approved", value: "1", icon: <CheckCircleIcon fontSize="small" /> },
      ],
    //   bottomText: "Available Balance",
      balance: 13,
      total: 15,
      color: "#4caf50",
      gradient: "linear-gradient(135deg, #4caf50, #2e7d32)",
      icon: <TrophyIcon />,
      description: "Accrued based on tenure",
      usage: 87,
      status: "Excellent",
      trend: "up",
      trendValue: "+2",
      badgeColor: "#2e7d32",
    },
    {
      id: 2,
      title: "COMPENSATORY LEAVE",
      details: [
        { label: "Credited", value: "5", icon: <AccessTimeIcon fontSize="small" /> },
        { label: "Total", value: "5", icon: <EventIcon fontSize="small" /> },
        { label: "Applied", value: "0", icon: <CalendarIcon fontSize="small" /> },
        { label: "Approved", value: "0", icon: <CheckCircleIcon fontSize="small" /> },
      ],
    //   bottomText: "Available Balance",
      balance: 5,
      total: 5,
      color: "#2196f3",
      gradient: "linear-gradient(135deg, #2196f3, #7564e6)",
      icon: <TrendingUpIcon />,
      description: "For overtime work",
      usage: 100,
      status: "Full",
      trend: "up",
      trendValue: "+5",
      badgeColor: "#7564e6",
    },
    {
      id: 3,
      title: "LOSS OF PAY",
      details: [
        { label: "Total LOP", value: "0", icon: <CancelIcon fontSize="small" /> },
      ],
      bottomText: "LOP Days",
      balance: 0,
      total: 0,
      color: "#f44336",
      gradient: "linear-gradient(135deg, #f44336, #c62828)",
      icon: <FavoriteIcon />,
      description: "Unpaid leave days",
      usage: 0,
      status: "No LOP",
      trend: "neutral",
      trendValue: "0",
      badgeColor: "#c62828",
    },
  ];

  const leaveTypeIcons = {
    "Sick Leave": <MedicalIcon />,
    "Casual Leave": <CelebrationIcon />,
    "Annual Leave": <VacationIcon />,
    "Paid Leave": <StarIcon />,
    "Maternity Leave": <FavoriteIcon />,
    "Paternity Leave": <FavoriteIcon />,
  };

  const leaveRecords = [
    {
      id: 1,
      month: "Jan",
      type: "Sick Leave",
      startDate: "2024-01-15",
      endDate: "2024-01-16",
      appliedDays: 2,
      approvedDays: 2,
      status: "Approved",
      remarks: "Fever and doctor consultation",
      icon: <MedicalIcon />,
    },
    {
      id: 2,
      month: "Feb",
      type: "Casual Leave",
      startDate: "2024-02-10",
      endDate: "2024-02-10",
      appliedDays: 1,
      approvedDays: 1,
      status: "Pending",
      remarks: "Family wedding function",
      icon: <CelebrationIcon />,
    },
    {
      id: 3,
      month: "Mar",
      type: "Annual Leave",
      startDate: "2024-03-20",
      endDate: "2024-03-25",
      appliedDays: 5,
      approvedDays: 5,
      status: "Approved",
      remarks: "Summer vacation with family",
      icon: <VacationIcon />,
    },
  ];

  const isAllSelected = leaveRecords.length > 0 && selectedRows.length === leaveRecords.length;

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(leaveRecords.map((_, index) => index));
    }
  };

  const handleRowSelect = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((i) => i !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!leaveType) newErrors.leaveType = "Leave type is required";
    if (!startDate) newErrors.startDate = "Start date is required";
    if (!endDate) newErrors.endDate = "End date is required";
    if (dayjs(endDate).isBefore(dayjs(startDate))) {
      newErrors.endDate = "End date must be after start date";
    }
    if (!reason.trim()) newErrors.reason = "Reason is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      console.log("Leave Request Submitted:", {
        leaveType,
        startDate,
        halfStart,
        endDate,
        halfEnd,
        reason,
        attachment,
      });
      // Reset form
      setLeaveType("");
      setStartDate(null);
      setHalfStart("");
      setEndDate(null);
      setHalfEnd("");
      setReason("");
      setAttachment(null);
      setErrors({});
      setOpenLeaveDialog(false);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setAttachment(file);
    }
  };

  const handleRemoveAttachment = () => {
    setAttachment(null);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Approved": return "success";
      case "Pending": return "warning";
      case "Rejected": return "error";
      default: return "default";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "Approved": return <CheckCircleIcon fontSize="small" />;
      case "Pending": return <PendingIcon fontSize="small" />;
      case "Rejected": return <CancelIcon fontSize="small" />;
      default: return null;
    }
  };

  const handleExportData = () => {
    console.log("Exporting leave data...");
  };

  const handlePreviousYear = () => {
    setCurrentYear(currentYear - 1);
  };

  const handleNextYear = () => {
    setCurrentYear(currentYear + 1);
  };

  const getUsageColor = (percentage) => {
    if (percentage >= 80) return "#2e7d32";
    if (percentage >= 50) return "#ed6c02";
    return "#d32f2f";
  };

  const LeaveBalanceCard = ({ leave }) => (
    <Card 
      sx={{ 
        height: "100%",
        width:"350px",
        borderRadius: 3,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
        transition: "all 0.3s ease",
        position: "relative",
        overflow: "hidden",
        background: "white",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 12px 40px rgba(0, 0, 0, 0.15)",
        }
      }}
    >
      {/* Decorative Corner */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          width: 80,
          height: 80,
          background: alpha(leave.color, 0.08),
          borderBottomLeftRadius: 80,
        }}
      />
      
      <CardContent sx={{ position: "relative", zIndex: 1, p: 3 }}>
        {/* Header with Icon and Title */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1 }}>
              <Avatar 
                sx={{ 
                  bgcolor: `${leave.color}15`,
                  color: leave.color,
                  width: 44,
                  height: 44,
                }}
              >
                {leave.icon}
              </Avatar>
              <Box>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: leave.color,
                    fontWeight: 700,
                    fontSize: "1.1rem"
                  }}
                >
                  {leave.title}
                </Typography>
                <Typography 
                  variant="caption" 
                  sx={{ 
                    color: "text.secondary",
                    display: "block",
                  }}
                >
                  {leave.description}
                </Typography>
              </Box>
            </Box>
          </Box>
          
          {/* Trend Indicator */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {leave.trend === "up" ? (
              <ArrowUpIcon sx={{ color: "#4caf50", fontSize: 18 }} />
            ) : leave.trend === "down" ? (
              <ArrowDownIcon sx={{ color: "#f44336", fontSize: 18 }} />
            ) : null}
            <Typography 
              variant="caption" 
              sx={{ 
                color: leave.trend === "up" ? "#4caf50" : leave.trend === "down" ? "#f44336" : "text.secondary",
                fontWeight: 700,
                fontSize: "0.85rem"
              }}
            >
              {leave.trendValue}
            </Typography>
          </Box>
        </Box>
        
        {/* Main Balance Display */}
        <Box sx={{ textAlign: "center", my: 2 }}>
          <Box sx={{ position: "relative", display: "inline-flex" }}>
            <CircularProgress 
              variant="determinate" 
              value={leave.usage}
              size={120}
              thickness={4}
              sx={{ 
                color: leave.color,
              }}
            />
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: "absolute",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography 
                variant="h3" 
                sx={{ 
                  color: leave.color,
                  fontWeight: 800,
                  lineHeight: 1,
                  fontSize: "2.5rem"
                }}
              >
                {leave.balance}
              </Typography>
              <Typography 
                variant="caption" 
                sx={{ 
                  color: "text.secondary",
                  mt: 0.5,
                  fontWeight: 500
                }}
              >
                {leave.bottomText}
              </Typography>
            </Box>
          </Box>
          
          {/* Status Chip */}
          <Chip
            label={leave.status}
            size="small"
            sx={{ 
              bgcolor: `${leave.badgeColor}15`,
              color: leave.badgeColor,
              fontWeight: 600,
              height: 28,
              mt: 2,
              px: 1
            }}
          />
        </Box>
        
        <Divider sx={{ my: 2 }} />
        
        {/* Details Grid */}
        <Grid container spacing={1}>
          {leave.details.map((detail, index) => (
            <Grid item xs={6} key={index}>
              <Box sx={{ 
                p: 1.5, 
                borderRadius: 2, 
                bgcolor: `${leave.color}08`,
                border: `1px solid ${alpha(leave.color, 0.1)}`,
                height: "100%"
              }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
                  <Box sx={{ 
                    color: leave.color,
                    display: "flex",
                    alignItems: "center"
                  }}>
                    {detail.icon}
                  </Box>
                  <Typography 
                    variant="caption" 
                    sx={{ 
                      color: "text.secondary",
                      fontWeight: 500,
                      fontSize: "0.7rem"
                    }}
                  >
                    {detail.label}
                  </Typography>
                </Box>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    color: leave.color,
                    fontWeight: 700,
                    fontSize: "1.25rem"
                  }}
                >
                  {detail.value}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        
        {/* Usage Bar */}
        <Box sx={{ mt: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5 }}>
            <Typography variant="caption" color="text.secondary">
              Usage
            </Typography>
            <Typography 
              variant="caption" 
              sx={{ 
                color: getUsageColor(leave.usage),
                fontWeight: 700,
              }}
            >
              {leave.usage}%
            </Typography>
          </Box>
          <LinearProgress 
            variant="determinate" 
            value={leave.usage} 
            sx={{ 
              height: 8, 
              borderRadius: 4,
              bgcolor: `${leave.color}20`,
              "& .MuiLinearProgress-bar": {
                bgcolor: getUsageColor(leave.usage),
                borderRadius: 4,
              }
            }} 
          />
        </Box>
      </CardContent>
    </Card>
  );

  const MobileLeaveRecord = ({ record }) => (
    <Card sx={{ 
      mb: 2, 
      borderLeft: `4px solid ${theme.palette[getStatusColor(record.status)].main}`,
      borderRadius: 2,
      overflow: "hidden"
    }}>
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Avatar sx={{ 
              bgcolor: `${theme.palette[getStatusColor(record.status)].main}20`,
              color: theme.palette[getStatusColor(record.status)].main,
              width: 40,
              height: 40
            }}>
              {record.icon}
            </Avatar>
            <Box>
              <Typography variant="subtitle1" fontWeight={700}>
                {record.type}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <CalendarIcon fontSize="small" />
                {record.startDate} - {record.endDate}
              </Typography>
            </Box>
          </Box>
          <Chip
            label={record.status}
            color={getStatusColor(record.status)}
            size="small"
            icon={getStatusIcon(record.status)}
            sx={{ fontWeight: 600 }}
          />
        </Box>

        <Grid container spacing={1} sx={{ mt: 2 }}>
          <Grid item xs={6}>
            <Box sx={{ 
              p: 1.5, 
              borderRadius: 2, 
              bgcolor: "primary.light",
              border: "1px solid",
              borderColor: "primary.100"
            }}>
              <Typography variant="caption" color="text.secondary">
                Applied Days
              </Typography>
              <Typography variant="h6" fontWeight={700} color="primary.main">
                {record.appliedDays}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ 
              p: 1.5, 
              borderRadius: 2, 
              bgcolor: "success.light",
              border: "1px solid",
              borderColor: "success.100"
            }}>
              <Typography variant="caption" color="text.secondary">
                Approved Days
              </Typography>
              <Typography variant="h6" fontWeight={700} color="success.main">
                {record.approvedDays}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 1.5, p: 1.5, bgcolor: "grey.50", borderRadius: 2 }}>
              <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
                Remarks
              </Typography>
              <Typography variant="body2" sx={{ fontStyle: "italic" }}>
                "{record.remarks}"
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ 
        bgcolor: "#f8fafc", 
        minHeight: "100vh",
        py: { xs: 2, sm: 3, md: 4 },
        px: { xs: 1.5, sm: 2, md: 3 }
      }}>
        {/* Header */}
        {/* <Box sx={{ mb: 4 }}>
          <Typography variant="h4" fontWeight={800} color="primary" gutterBottom sx={{ fontSize: { xs: "1.75rem", sm: "2rem" } }}>
            Leave Management Dashboard
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600 }}>
            Track your leave balance, apply for time off, and manage all your leave requests in one place
          </Typography>
        </Box> */}

        {/* Leave Balance Cards - Single Row */}
        <Box sx={{ mb: 4 }}>
          <Grid container spacing={3}>
            {leaveData.map((leave) => (
              <Grid item xs={12} md={4} key={leave.id}>
                <LeaveBalanceCard leave={leave} />
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Action Buttons and Year Selection */}
        <Card sx={{ mb: 4, borderRadius: 3, boxShadow: 3, overflow: "hidden" }}>
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={6}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box sx={{ 
                    p: 1.5, 
                    borderRadius: 2, 
                    bgcolor: "primary.50",
                    border: "2px solid",
                    borderColor: "primary.100"
                  }}>
                    <Typography variant="h5" fontWeight={800} color="primary.main">
                      {currentYear}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <IconButton 
                      onClick={handlePreviousYear}
                      sx={{ 
                        bgcolor: "primary.50",
                        color: "primary.main",
                        "&:hover": { bgcolor: "primary.100" }
                      }}
                    >
                      <ChevronLeftIcon />
                    </IconButton>
                    <IconButton 
                      onClick={handleNextYear}
                      sx={{ 
                        bgcolor: "primary.50",
                        color: "primary.main",
                        "&:hover": { bgcolor: "primary.100" }
                      }}
                    >
                      <ChevronRightIcon />
                    </IconButton>
                  </Box>
                </Box>
              </Grid>
              
              <Grid item xs={12} md={6}>
                <Box sx={{ 
                  display: "flex", 
                  gap: 2, 
                  justifyContent: { xs: "flex-start", md: "flex-end" },
                  flexWrap: "wrap" 
                }}>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => setOpenLeaveDialog(true)}
                    sx={{ 
                      bgcolor: "#7564e6",
                      borderRadius: 2,
                      fontWeight: 700,
                      px: 4,
                      py: 1.5,
                      "&:hover": { 
                        bgcolor: "#7564e6",
                        transform: "translateY(-2px)",
                        boxShadow: 4
                      },
                      transition: "all 0.2s"
                    }}
                  >
                    Apply Leave
                  </Button>
                  
                  <Button
                    variant="outlined"
                    startIcon={<VisibilityIcon />}
                    onClick={() => setOpenLeaveDetails(true)}
                    sx={{ 
                      borderRadius: 2,
                      fontWeight: 700,
                      px: 4,
                      py: 1.5,
                      borderWidth: 2,
                      "&:hover": { 
                        borderWidth: 2,
                        transform: "translateY(-2px)",
                        boxShadow: 2
                      },
                      transition: "all 0.2s"
                    }}
                  >
                    View Details
                  </Button>
                  
                  <Button
                    variant="contained"
                    startIcon={<DownloadIcon />}
                    onClick={handleExportData}
                    sx={{ 
                      bgcolor: "#C38238",
                      borderRadius: 2,
                      fontWeight: 700,
                      px: 4,
                      py: 1.5,
                      "&:hover": { 
                        bgcolor: "#B17330",
                        transform: "translateY(-2px)",
                        boxShadow: 4
                      },
                      transition: "all 0.2s"
                    }}
                  >
                    Export
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Monthly Summary Table */}
        <Card sx={{ borderRadius: 3, boxShadow: 3, overflow: "hidden", mb: 4 }}>
          <CardHeader 
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CalendarIcon color="primary" />
                <Typography variant="h6" fontWeight={700}>
                  Recent Leave Requests
                </Typography>
              </Box>
            }
            titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
            action={
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <InputLabel>Filter by Status</InputLabel>
                <Select
                  value={filterStatus}
                  onChange={(e) => setFilterStatus(e.target.value)}
                  label="Filter by Status"
                >
                  <MenuItem value="all">All Status</MenuItem>
                  <MenuItem value="Approved">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CheckCircleIcon fontSize="small" color="success" />
                      Approved
                    </Box>
                  </MenuItem>
                  <MenuItem value="Pending">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <PendingIcon fontSize="small" color="warning" />
                      Pending
                    </Box>
                  </MenuItem>
                  <MenuItem value="Rejected">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CancelIcon fontSize="small" color="error" />
                      Rejected
                    </Box>
                  </MenuItem>
                </Select>
              </FormControl>
            }
            sx={{ borderBottom: "1px solid", borderColor: "divider" }}
          />
          
          {isMobile ? (
            // Mobile View
            <CardContent>
              {leaveRecords.map((record) => (
                <MobileLeaveRecord key={record.id} record={record} />
              ))}
            </CardContent>
          ) : (
            // Desktop/Tablet View
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: "primary.50" }}>
                    <TableCell sx={{ fontWeight: 700 }}>Month</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Period</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Applied Days</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Approved Days</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Remarks</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {leaveRecords.map((record) => (
                    <TableRow key={record.id} hover sx={{ transition: "background 0.2s" }}>
                      <TableCell>
                        <Chip 
                          label={record.month} 
                          size="small" 
                          sx={{ fontWeight: 600, bgcolor: "primary.100" }}
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                          <Avatar sx={{ 
                            width: 32, 
                            height: 32, 
                            bgcolor: `${theme.palette[getStatusColor(record.status)].main}20`,
                            color: theme.palette[getStatusColor(record.status)].main
                          }}>
                            {record.icon}
                          </Avatar>
                          <Typography variant="body2" fontWeight={600}>
                            {record.type}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ 
                          p: 1, 
                          borderRadius: 1, 
                          bgcolor: "grey.50",
                          display: "inline-block"
                        }}>
                          <Typography variant="body2" fontWeight={500}>
                            {record.startDate} - {record.endDate}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight={700} color="primary.main">
                          {record.appliedDays}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight={700} color="success.main">
                          {record.approvedDays}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={record.status}
                          color={getStatusColor(record.status)}
                          size="small"
                          icon={getStatusIcon(record.status)}
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>
                      <TableCell>
                        <Tooltip title={record.remarks}>
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              maxWidth: 200, 
                              overflow: "hidden", 
                              textOverflow: "ellipsis", 
                              whiteSpace: "nowrap" 
                            }}
                          >
                            {record.remarks}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={0.5}>
                          <Tooltip title="View Details">
                            <IconButton size="small" sx={{ color: "primary.main" }}>
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit">
                            <IconButton size="small" color="warning">
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton size="small" color="error">
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Card>

        {/* Yearly Summary Table */}
        <Card sx={{ borderRadius: 3, boxShadow: 3, overflow: "hidden" }}>
          <CardHeader 
            title={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EventIcon color="primary" />
                <Typography variant="h6" fontWeight={700}>
                  Yearly Leave Summary - {currentYear}
                </Typography>
              </Box>
            }
            titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
            sx={{ borderBottom: "1px solid", borderColor: "divider" }}
          />
          <TableContainer sx={{ maxHeight: isMobile ? 300 : 400, overflow: "auto" }}>
            <Table size={isMobile ? "small" : "medium"}>
              <TableHead>
                <TableRow sx={{ bgcolor: "#98C1D9" }}>
                  <TableCell sx={{ fontWeight: 700, border: "1px solid #ddd" }}>
                    Details
                  </TableCell>
                  {months.map((month) => (
                    <TableCell 
                      key={month} 
                      align="center" 
                      sx={{ fontWeight: 700, border: "1px solid #ddd" }}
                    >
                      {month}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.map((row, rowIndex) => (
                  <TableRow key={rowIndex} hover>
                    <TableCell 
                      sx={{ 
                        fontWeight: 600, 
                        border: "1px solid #ddd",
                        bgcolor: rowIndex % 2 === 0 ? "#f9f9f9" : "white",
                        position: "sticky",
                        left: 0,
                        zIndex: 1
                      }}
                    >
                      {row.label}
                    </TableCell>
                    {row.values.map((val, colIndex) => (
                      <TableCell 
                        key={colIndex} 
                        align="center"
                        sx={{ 
                          border: "1px solid #ddd",
                          bgcolor: rowIndex % 2 === 0 ? "#f9f9f9" : "white",
                          fontWeight: val > 0 ? 600 : 400,
                          color: val > 0 ? "primary.main" : "inherit"
                        }}
                      >
                        {val}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>

        {/* Apply Leave Dialog */}
        <Dialog
          open={openLeaveDialog}
          onClose={() => setOpenLeaveDialog(false)}
          maxWidth="sm"
          fullWidth
          fullScreen={isMobile}
          PaperProps={{ sx: { borderRadius: isMobile ? 0 : 3 } }}
        >
          <DialogTitle sx={{ 
            bgcolor: "#7564e6", 
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 3
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <AddIcon />
              <Typography variant="h6" fontWeight={700}>
                Apply for Leave
              </Typography>
            </Box>
            <IconButton 
              onClick={() => setOpenLeaveDialog(false)} 
              sx={{ color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          
          <DialogContent sx={{ mt: 2, p: 3 }}>
            <Stack spacing={3}>
              {/* Leave Type */}
              <FormControl fullWidth error={!!errors.leaveType}>
                <InputLabel>Leave Type *</InputLabel>
                <Select
                  value={leaveType}
                  onChange={(e) => setLeaveType(e.target.value)}
                  label="Leave Type *"
                  startAdornment={
                    leaveTypeIcons[leaveType] && (
                      <InputAdornment position="start">
                        {leaveTypeIcons[leaveType]}
                      </InputAdornment>
                    )
                  }
                >
                  <MenuItem value="Sick Leave">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <MedicalIcon fontSize="small" />
                      Sick Leave
                    </Box>
                  </MenuItem>
                  <MenuItem value="Casual Leave">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <CelebrationIcon fontSize="small" />
                      Casual Leave
                    </Box>
                  </MenuItem>
                  <MenuItem value="Annual Leave">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <VacationIcon fontSize="small" />
                      Annual Leave
                    </Box>
                  </MenuItem>
                  <MenuItem value="Paid Leave">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <StarIcon fontSize="small" />
                      Paid Leave
                    </Box>
                  </MenuItem>
                  <MenuItem value="Maternity Leave">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <FavoriteIcon fontSize="small" />
                      Maternity Leave
                    </Box>
                  </MenuItem>
                  <MenuItem value="Paternity Leave">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                      <FavoriteIcon fontSize="small" />
                      Paternity Leave
                    </Box>
                  </MenuItem>
                </Select>
                {errors.leaveType && (
                  <Typography variant="caption" color="error">
                    {errors.leaveType}
                  </Typography>
                )}
              </FormControl>

              {/* Start Date and Half */}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  {isMobile ? (
                    <MobileDatePicker
                      label="Start Date *"
                      value={startDate}
                      onChange={(date) => setStartDate(date)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={!!errors.startDate}
                          helperText={errors.startDate}
                        />
                      )}
                    />
                  ) : (
                    <DesktopDatePicker
                      label="Start Date *"
                      value={startDate}
                      onChange={(date) => setStartDate(date)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={!!errors.startDate}
                          helperText={errors.startDate}
                        />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth error={!!errors.halfStart}>
                    <InputLabel>Start Half</InputLabel>
                    <Select
                      value={halfStart}
                      onChange={(e) => setHalfStart(e.target.value)}
                      label="Start Half"
                    >
                      <MenuItem value="Full Day">Full Day</MenuItem>
                      <MenuItem value="First Half">First Half</MenuItem>
                      <MenuItem value="Second Half">Second Half</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* End Date and Half */}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  {isMobile ? (
                    <MobileDatePicker
                      label="End Date *"
                      value={endDate}
                      onChange={(date) => setEndDate(date)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={!!errors.endDate}
                          helperText={errors.endDate}
                        />
                      )}
                    />
                  ) : (
                    <DesktopDatePicker
                      label="End Date *"
                      value={endDate}
                      onChange={(date) => setEndDate(date)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={!!errors.endDate}
                          helperText={errors.endDate}
                        />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth error={!!errors.halfEnd}>
                    <InputLabel>End Half</InputLabel>
                    <Select
                      value={halfEnd}
                      onChange={(e) => setHalfEnd(e.target.value)}
                      label="End Half"
                    >
                      <MenuItem value="Full Day">Full Day</MenuItem>
                      <MenuItem value="First Half">First Half</MenuItem>
                      <MenuItem value="Second Half">Second Half</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* Reason */}
              <TextField
                label="Reason for Leave *"
                multiline
                rows={3}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                error={!!errors.reason}
                helperText={errors.reason}
                fullWidth
              />

              {/* Attachment */}
              <Box>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Attachment (Optional)
                </Typography>
                {attachment ? (
                  <Box sx={{ 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "space-between",
                    p: 1.5,
                    border: "1px dashed #ddd",
                    borderRadius: 1
                  }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <AttachFileIcon fontSize="small" />
                      <Typography variant="body2">
                        {attachment.name}
                      </Typography>
                    </Box>
                    <IconButton size="small" onClick={handleRemoveAttachment}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ) : (
                  <Button
                    component="label"
                    variant="outlined"
                    startIcon={<AttachFileIcon />}
                    fullWidth
                  >
                    Upload File
                    <input
                      type="file"
                      hidden
                      onChange={handleFileUpload}
                    />
                  </Button>
                )}
              </Box>
            </Stack>
          </DialogContent>

          <DialogActions sx={{ p: 3, borderTop: "1px solid", borderColor: "divider" }}>
            <Button 
              onClick={() => setOpenLeaveDialog(false)}
              variant="outlined"
              sx={{ borderRadius: 2, px: 4 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              startIcon={<SendIcon />}
              sx={{ 
                bgcolor: "#7564e6",
                borderRadius: 2,
                fontWeight: 700,
                px: 4,
                "&:hover": { bgcolor: "#7564e6" }
              }}
            >
              Submit Request
            </Button>
          </DialogActions>
        </Dialog>

        {/* Leave Details Dialog */}
        <Dialog
          open={openLeaveDetails}
          onClose={() => setOpenLeaveDetails(false)}
          maxWidth="lg"
          fullWidth
          fullScreen={isMobile}
          PaperProps={{ sx: { borderRadius: isMobile ? 0 : 3 } }}
        >
          <DialogTitle sx={{ 
            bgcolor: "#98C1D9", 
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 3
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <VisibilityIcon />
              <Typography variant="h6" fontWeight={700}>
                Leave Details
              </Typography>
            </Box>
            <IconButton 
              onClick={() => setOpenLeaveDetails(false)} 
              sx={{ color: "white" }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ mt: 2, p: 3 }}>
            <TableContainer sx={{ maxHeight: 400 }}>
              <Table size={isMobile ? "small" : "medium"}>
                <TableHead>
                  <TableRow sx={{ bgcolor: "#f5f7fa" }}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                        indeterminate={selectedRows.length > 0 && selectedRows.length < leaveRecords.length}
                      />
                    </TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Month</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Type</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Start Date</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>End Date</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Applied Days</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Approved Days</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Remarks</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {leaveRecords.map((record, index) => (
                    <TableRow key={record.id} hover selected={selectedRows.includes(index)}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedRows.includes(index)}
                          onChange={() => handleRowSelect(index)}
                        />
                      </TableCell>
                      <TableCell>
                        <Chip label={record.month} size="small" />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          {record.icon}
                          <Typography variant="body2" fontWeight={500}>
                            {record.type}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{record.startDate}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{record.endDate}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight={600}>
                          {record.appliedDays}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight={600} color="success.main">
                          {record.approvedDays}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={record.status}
                          color={getStatusColor(record.status)}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">{record.remarks}</Typography>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>

          <DialogActions sx={{ p: 3, borderTop: "1px solid", borderColor: "divider" }}>
            <Button 
              onClick={() => setOpenLeaveDetails(false)}
              variant="contained"
              sx={{ borderRadius: 2, px: 4 }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </LocalizationProvider>
  );
}

export default LeaveAttendance;